import * as constants from './constants';
import {get, post} from "../../../utils/request";
import {ORDER_CONSUME} from '../../../utils/api';

export const ConsumeList = (Entity) => ({
    type: constants.CONSUME_LIST,
    value: Entity
});

export const getConsumeList = (params) => {
    return (dispatch) => {
        return post(ORDER_CONSUME, params)
            .then((response) => {
                return dispatch(ConsumeList(response.data));
            });
    }
};
